export enum AppealHeaderLabels {
  ClaimId = 'Claim ID',
  ClientClaimID = 'Client Claim ID',
  CreateDate = 'Create Date',
  DateCompleted = 'Complete Date',
  Source = 'Source',
  CreatedBy = 'Created By',
  Company = 'Company (Client Name)',
  Email = 'Email Address',
  Phone = 'Phone Number ',
  Fax = 'Fax Number',
  AssignedToCodeEdit = 'Assigned To (Code Edit) ',
  AssignedToIRN = 'Assigned To (IRN) ',
  AssignedToInsightReview = 'Assigned To (IRR) ',
  ProviderContact = 'Provider Contact',
  ReasonForAppeal = 'Reason for Appeal (IRN services only)',
  clientComments = 'Client Comments',
  comments = 'Optum Comments',
  ClosedBy = 'Closed By',
}

export enum AppealWorkQueueTypes {
  all = 'all',
  new = 'new',
  open = 'open',
  hold = 'hold',
  reopen = 'reopen',
  pend = 'pend',
}
